/** Persisted from `?portalAuthCode=` and sent as `X-Portal-Auth-Code` on portal API calls. */
export const PORTAL_AUTH_CODE_STORAGE_KEY = `pn-portal-auth-code`;
